import { ModifiableInfoFormProps } from './modifiableInfoForm.interface';
import { ModifiedForm } from './ModifiedForm';
import { InitialForm } from './InitialForm';

export const ModifiableInfoForm = ({ data, isModified }: ModifiableInfoFormProps) =>
  isModified ? <ModifiedForm data={data} /> : <InitialForm data={data} />;
